import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class RxOverrideType extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> Financial constructor -', init)
    if (isNil(init)) return undefined
    this._claim_id = init.claim_id
    this._medication = init.medication
    this._requested_by = init.requested_by
    this._status = init.status
    this._reason = init.reason
  }

  static shape = {
    claim_id: PropTypes.string,
    medication: PropTypes.string,
    requested_by: PropTypes.string,
    status: PropTypes.string,
    reason: PropTypes.string
  }

  get claim_id() {
    return this._claim_id
  }

  get medication() {
    return this._medication
  }

  get requested_by() {
    return this._requested_by
  }
  get status() {
    return this._status
  }
  get reason() {
    return this._reason
  }
}

export default RxOverrideType
